var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:[
        'checkbox-item',
        {
            'checkbox-item_disabled': _vm.disabled,
            'checkbox-item_medium': _vm.checkBoxSize === 'medium',
            'checkbox-item__auth-reg': _vm.isAuthOrRegistration
        }
    ],attrs:{"id":_vm.domId,"data-checkbox":_vm.checkboxKey,"title":_vm.label}},[_c('input',{attrs:{"type":"checkbox","data-role":"none","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_vm._v(" "),(_vm.loading)?_c('Spinner',{staticClass:"checkbox-item__spinner",attrs:{"size":"xs"}}):_c('span',{class:[
            'checkbox-item__icon',
        {
            'checkbox-item__icon-locked': _vm.iconLocked
        }
        ]},[_c('span',{staticClass:"icon icon-i16_check_thin"})]),_vm._v(" "),(_vm.isAuthOrRegistration)?_c('small',{class:[
            'checkbox-item__text-checkbox',
            'text-common text-common__text',
            'text-common_text-small',
        {
            'checkbox-item__text_hide-overflow-text': _vm.hideOverflowText
        }
        ]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_c('span',{class:[
            'checkbox-item__text',
        {
            'checkbox-item__text_hide-overflow-text': _vm.hideOverflowText
        }
        ]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }